module.exports = __webpack_public_path__ + "static/media/Screenshot_9.b5095ad4.png";